/// <amd-module name="Artifacts/Root/types/IPackageVersionIdentity" />
import { Protocol } from "Artifacts/Root/Constants";

/**
 * Minimal unique representation of a package version for interacting
 * with packaging APIs
 */
export interface IPackageVersionIdentity {
  /**
   * The display name of the package.
   */
  name: string;
  /**
   * The guid id of the package (not package version).
   */
  packageId: string;
  /**
   * Display version number.
   */
  version: string;
  /**
   * Normalized version number.
   */
  normalizedVersion: string;
  /**
   * Package protocol.
   */
  protocol: Protocol;
  /**
   * View names of the package.
   */
  views: string[];
  /**
   * (NuGet and Cargo Only) True if this package is listed.
   */
  isListed?: boolean;

  /**
   * True if this package is deleted.
   */
  isDeleted: boolean;
}
